import { AfterContentInit, Component, OnInit } from '@angular/core';
import { RestService } from '../../shared/service/rest.service';
import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader'; // Import NgxUiLoaderService
import { AbstractDataProvider } from '../AbstractDataProvider';
import { DictionaryPipe } from '../../shared/pipes/dictionary.pipe';
import { finalize } from 'rxjs/operators';
import {getErrorMessageText} from '../helper';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-username.component.html',
  styleUrls: ['./forgot-username.component.scss'],
  providers: [DictionaryPipe]
})
export class ForgotUsernameComponent implements OnInit, AfterContentInit {
  email: string;
  display = false;
  displaySuccessMessage: boolean;
  alertMessage: string;
  methodToCallAfterDialogClose: string;

  clientCode: string;
  clientName: string;
  clientPhoneNumber: string;
  bgImageUrl: string;

  constructor(
    public rest: RestService,
    private authService: AuthServiceCustom,
    private ngxService: NgxUiLoaderService,
    private abstractDataProvider: AbstractDataProvider,
    private route: ActivatedRoute,
    private dictionaryPipe: DictionaryPipe
  ) {
  }

  ngOnInit() {
    this.bgImageUrl = this.authService.clientBackgroundImageUrl;
    this.authService.accessTokenRemovedSubj.next(true);

  }

  ngAfterContentInit() {
    this.clientCode = this.authService.clientCode;
    this.clientName = this.authService.wpCompanyName;
    this.clientPhoneNumber = this.authService.wpContactPhone;
  }

  submit(): void {
    if (!this.email) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('ENTER_EMAIL');
      return;
    }
    if (!this.authService.validateEmail(this.email)) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('INVALID_EMAIL_ADDRESS');
      return;
    }
    this.ngxService.start();
    this.abstractDataProvider.postData({Email: this.email}, 'api/Accounts/SendUserName')
      .pipe(finalize(() => this.ngxService.stop())).subscribe(() => {
      this.displaySuccessMessage = true;
    }, error => {
      this.display = true;
      this.alertMessage =  getErrorMessageText(error);
    });
  }

  onConfirm(): void {
    this.display = false;
  }

  hidePopupAndNavigateHome() {
    this.displaySuccessMessage = false;
    this.authService.navigateToLogin();
  }


  cancel() {
    this.authService.navigateToLogin();
  }
}
